'use strict';

/**
 * Daashboard Service
 */
module.service('dashboardService', [ 'Restangular', '$q', dashboardServiceFn ]);

function dashboardServiceFn(Restangular, $q) {

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */
	var dashboardPath = '/dashboard';

	var ss = {};

	ss.getClient = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(dashboardPath).customGET('client', null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.getCM = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(dashboardPath).customGET('', null).then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.getCMByDays = function(start,end) {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(dashboardPath).one("start", start).one("end", end).get().then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};
	
	ss.consolidateByDayPruebas = function() {
		var deferred = $q.defer();
		var answer = new restResponse();
		Restangular.all(dashboardPath).customGET('consolidatebydaypruebas').then(function(response) {
			answer.handleSuccessfullResponse(response, response.data);
			deferred.resolve(answer);
		}, function(response) {
			answer.handleErrorResponse(response, response.data);
			deferred.reject(answer);
		});
		return deferred.promise;
	};

	return ss;
}
